<template>
  <div>
    <v-row style="background-color: #385CC2" class="pa-2" v-if="hasContact">
      <v-col
        class="d-flex justify-center align-center flex-wrap flex-column col-11 col-lg-6"
      >
        <h2 style="color:white">Venha fazer parte da mudança!</h2>
        <v-avatar color="white" size="240" class="mt-5  elevation-5">
          <v-img
            alt="Logo"
            class="shrink "
            contain
            src="../assets/logo.png"
            transition="scale-transition"
            width="220"
          />
        </v-avatar>
      </v-col>
      <v-col class="col-11 col-lg-5 ml-2 ml-lg-0">
        <ContactForm />
      </v-col>
    </v-row>
    <v-row style="background-color: #385CC2" class="mt-1">
      <v-col
        class="col-12 col-lg-5 d-flex flex-column ml-4 justify-center align-center"
      >
        <h3 style="margin-left: -7em;color:white">Redes sociais</h3>
        <div class="d-inline-flex">
          <v-card
            v-for="(socialMedia, i) in socialMedias"
            :key="i"
            class="mr-4 mt-2 pa-2"
            color="#ddd"
          >
            <v-icon style="font-size:2em">
              {{ socialMedia.icon }}
            </v-icon>
          </v-card>
        </div>
      </v-col>
      <v-col
        class="col-11 col-lg-5 d-flex flex-column ml-4 justify-left align-left"
      >
        <h3 style="color:white; float-left">Sobre</h3>
        <p style="color:white;">
          A Drell é uma empresa de engenharia elétrica criada para facilitar a
          entrega e distribuição de energia. Com ela você sempre tem a melhor e
          mais confiável fonte de energia.
        </p>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import ContactForm from "@/components/ContactForm.vue";

export default {
  props: {
    hasContact: {
      type: Boolean
    }
  },
  components: {
    ContactForm
  },
  data() {
    return {
      socialMedias: [
        {
          icon: "mdi-facebook",
          alias: "facebook"
        },
        {
          icon: "mdi-twitter",
          alias: "twitter"
        },
        {
          icon: "mdi-instagram",
          alias: "instagram"
        },
        {
          icon: "mdi-youtube",
          alias: "youtube"
        }
      ]
    };
  }
};
</script>
